module.exports = __webpack_public_path__ + "static/media/product.f439c50a.png";